export const GET_PROJECT_CHARTER = 'GET_PROJECT_CHARTER'
export const ADDEDIT_INTRODUCTION = 'ADDEDIT_INTRODUCTION'

export const AE_PROJECT_GOAL = 'AE_PROJECT_GOAL'
export const AE_PROJECT_LIMITATION = 'AE_PROJECT_LIMITATION'
export const AE_PROJECT_RISK = 'AE_PROJECT_RISK'
export const AE_PROJECT_IMP_TIMES = 'AE_PROJECT_IMP_TIMES'
export const AE_PROJECT_RULES = 'AE_PROJECT_RULES'
export const AE_PROJECT_DODS = 'AE_PROJECT_DODS'
export const AE_PROJECT_EPICS = 'AE_PROJECT_EPICS'
export const AE_PROJECT_PERSONAS = 'AE_PROJECT_PERSONAS'
export const GET_MILESTONE_TASKS = 'GET_MILESTONE_TASKS'

export const GET_PROJECT_BENEFICARES = 'GET_PROJECT_BENEFICARES'

export const GET_TASK_CHARTER = 'GET_TASK_CHARTER'
export const GET_TASKMAP_CHARTER = 'GET_TASKMAP_CHARTER'
